import { Component, Inject, Input } from '@angular/core';

import { MAP_POPUP_DATA } from '@lib/geo/map/providers';

@Component({
  selector: 'fs-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
})
export class FsPopupComponent {
  public text: string;

  constructor(@Inject(MAP_POPUP_DATA) public data: any) {
    this.text = data.data.text;
  }
}
